(function () {
  'use strict';

  angular
      .module('tf.retailer.Charts')
      .directive('tfcChart', tfcChart);

  // @ngInject
  function tfcChart($window, ngUtil) {
    return {
      restrict : 'E',
      scope : {
        chart : '@',
        data : '=',
        options : '='
      },
      link : function ($scope, $el, $attrs) {
        var $w = angular.element($window);
        var eventBinder = ngUtil.eventBinder($scope);

        var svg = d3.select($el[0]).append('svg');
        var chart;

        function createChart() {
          if (!chart) {
            chart = svg.chart($scope.chart, $scope.options || {});
          }
        }

        $scope.$watch('data', function (data) {
          if (data && _.size(data) !== 0) {
            createChart();
            chart.draw(data);
            updateChartSize(elemSize());
          }
          $el[0].parentNode.scrollTop = $el[0].scrollTop;
        });

        function elemSize() {
          return {
            width : $el[0].offsetWidth,
            height : $el[0].offsetHeight
          };
        }

        eventBinder($w, 'resize', function () {
          $scope.$apply();
        });

        $scope.$watch(elemSize, updateChartSize, true);
        function updateChartSize(size) {
          if (chart) {
            chart
                .width(size.width)
                .height(size.height);
          }
        }
      }
    };
  }

})();
